import { render, staticRenderFns } from "./GMultiCheckbox.vue?vue&type=template&id=98606a22&scoped=true&"
import script from "./GMultiCheckbox.vue?vue&type=script&lang=ts&"
export * from "./GMultiCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./GMultiCheckbox.vue?vue&type=style&index=0&id=98606a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98606a22",
  null
  
)

export default component.exports